export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-movie-line', description: '最新热门电影在线观看' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line', description: '热门电视剧全集播放' },
  { slug: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line', description: '精彩综艺节目在线看' },
  { slug: 'anime', name: '动漫', icon: 'ri-ghost-line', description: '日漫国漫高清播放' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line', description: '精品纪录片免费观看' },
  { slug: 'music', name: '音乐', icon: 'ri-music-line', description: '音乐MV演唱会直播' },
  { slug: 'sports', name: '体育', icon: 'ri-basketball-line', description: '体育赛事精彩回放' },
  { slug: 'game', name: '游戏', icon: 'ri-gamepad-line', description: '游戏实况攻略解说' },
];

export const articles = [
  {
    id: 1,
    slug: '2024-top-movies',
    title: '2024年必看的十大热门电影推荐',
    excerpt: '盘点2024年最值得观看的十部热门电影，涵盖动作、科幻、喜剧、悬疑等多种类型，每一部都不容错过。',
    content: '<p>2024年是电影产业的丰收之年，众多优秀作品涌现。红桃视频在线观看为您精心挑选了十部必看的热门电影，让您足不出户就能享受影院级的观影体验。</p><h2>1. 《星际征途》</h2><p>一部震撼人心的科幻巨制，讲述了人类在宇宙深处的冒险故事。视觉效果令人惊叹，剧情紧凑，演员表现出色。红桃视频在线观看提供高清画质，让您沉浸在这部科幻大片中。</p><h2>2. 《风雨人生》</h2><p>一部温暖人心的剧情片，讲述普通人在逆境中坚守希望的故事。影片情感真挚，画面优美，获得多个国际电影节提名。</p><h2>3. 《急速追踪》</h2><p>动作片爱好者的必看之作，全程高能，打斗场面精彩绝伦。红桃视频在线观看高清播放，让每一个动作细节都清晰可见。</p><h2>4. 《迷雾深处》</h2><p>悬疑推理佳片，剧情层层递进，结局令人意想不到。喜欢烧脑推理的观众一定不要错过。</p><h2>5. 《欢乐一家人》</h2><p>轻松愉快的家庭喜剧，适合全家人一起观看。笑点密集，温情满满。</p><p>更多精彩电影，尽在红桃视频在线观看。我们每日更新最新电影资源，让您第一时间观看热门大片。</p>',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20movie%20theater%20interior%20with%20warm%20cinematic%20lighting%2C%20red%20velvet%20seats%2C%20golden%20decorative%20accents%2C%20film%20projector%20aesthetic%2C%20professional%20photography%2C%20rich%20color%20grading%2C%20atmospheric%20composition&width=800&height=450&seq=article-movie-01&orientation=landscape',
    views: 15280,
    date: '2024-12-15',
    author: '红桃编辑',
    featured: true,
  },
  {
    id: 2,
    slug: 'best-tv-series-2024',
    title: '2024年高分电视剧盘点：这些剧集值得追',
    excerpt: '整理2024年豆瓣高分电视剧榜单，从古装到现代，从悬疑到爱情，总有一部适合你。',
    content: '<p>2024年的电视剧市场精彩纷呈，各类优质剧集层出不穷。红桃视频在线观看为您整理了年度高分电视剧，让您追剧不再迷茫。</p><h2>古装篇</h2><p>古装剧一直是观众最喜爱的类型之一。今年的古装剧制作精良，从服化道到剧情都达到了新高度。红桃视频在线观看收录了多部高分古装剧，画质高清，让您感受古风之美。</p><h2>现代篇</h2><p>现代都市剧贴近生活，反映当代人的情感与奋斗。今年的现代剧题材多样，有职场、爱情、家庭等多种元素。</p><h2>悬疑篇</h2><p>悬疑剧爱好者今年有福了！多部高质量悬疑剧集上线，剧情烧脑，制作精良。红桃视频在线观看为您提供流畅的观看体验。</p>',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20with%20large%20TV%20screen%20displaying%20colorful%20content%2C%20soft%20ambient%20lighting%2C%20comfortable%20couch%2C%20evening%20mood%2C%20cinematic%20atmosphere%2C%20rich%20warm%20tones&width=800&height=450&seq=article-tv-02&orientation=landscape',
    views: 12350,
    date: '2024-12-10',
    author: '红桃编辑',
    featured: true,
  },
  {
    id: 3,
    slug: 'variety-show-highlights',
    title: '热门综艺节目精彩看点大盘点',
    excerpt: '本季最火爆的综艺节目精彩集锦，搞笑、竞技、音乐、旅行，各类综艺一网打尽。',
    content: '<p>综艺节目是放松心情的最佳选择。红桃视频在线观看为您盘点了当前最热门的综艺节目，让您在闲暇时光尽情欢笑。</p><h2>搞笑综艺</h2><p>欢乐无限，笑料不断。这些搞笑综艺节目让您在工作学习之余放松心情。</p><h2>竞技综艺</h2><p>紧张刺激的竞技类综艺，让您感受选手们的拼搏精神。</p><h2>音乐综艺</h2><p>美妙的音乐，动人的歌声，音乐综艺带给您极致的听觉享受。</p>',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20TV%20variety%20show%20studio%20set%20with%20bright%20stage%20lights%2C%20entertainment%20production%2C%20dynamic%20energy%2C%20warm%20vibrant%20colors%2C%20professional%20broadcast%20equipment%2C%20lively%20atmosphere&width=800&height=450&seq=article-variety-03&orientation=landscape',
    views: 8920,
    date: '2024-12-08',
    author: '红桃编辑',
    featured: false,
  },
  {
    id: 4,
    slug: 'top-anime-winter',
    title: '冬季必追动漫推荐：温暖你的冬日时光',
    excerpt: '精选冬季最适合窝在被窝里观看的动漫作品，热血、治愈、搞笑，总有一款适合你。',
    content: '<p>冬天是追番的最佳季节。红桃视频在线观看为您推荐冬季必追动漫，让温暖的动漫陪伴您度过寒冷的冬日。</p><h2>热血番</h2><p>燃到爆炸的战斗场面，让人热血沸腾的剧情发展。</p><h2>治愈番</h2><p>温暖人心的日常故事，治愈你疲惫的心灵。</p><h2>搞笑番</h2><p>轻松愉快的搞笑动漫，让您开怀大笑。</p>',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20winter%20scene%20with%20warm%20cozy%20room%2C%20soft%20lighting%2C%20colorful%20art%20style%2C%20manga%20books%20on%20desk%2C%20hot%20drink%2C%20peaceful%20atmosphere%2C%20aesthetic%20composition&width=800&height=450&seq=article-anime-04&orientation=landscape',
    views: 10560,
    date: '2024-12-05',
    author: '红桃编辑',
    featured: false,
  },
  {
    id: 5,
    slug: 'nature-documentary-guide',
    title: '不可错过的自然纪录片：探索地球之美',
    excerpt: '精选五部制作精良的自然纪录片，带你领略地球的壮丽景观和神奇生命。',
    content: '<p>纪录片是了解世界的最佳窗口。红桃视频在线观看为您推荐五部不可错过的自然纪录片，带您探索地球的奥秘。</p><h2>海洋篇</h2><p>深入海底世界，探索神秘的海洋生物。</p><h2>陆地篇</h2><p>从热带雨林到极地冰川，领略地球的壮美景观。</p><h2>动物篇</h2><p>观察野生动物的生存智慧，感受生命的奇迹。</p>',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20nature%20landscape%20with%20mountains%20and%20lake%2C%20golden%20sunset%20light%2C%20wildlife%20documentary%20style%2C%20cinematic%20photography%2C%20rich%20earthy%20warm%20tones%2C%20breathtaking%20scenery&width=800&height=450&seq=article-doc-05&orientation=landscape',
    views: 7840,
    date: '2024-12-01',
    author: '红桃编辑',
    featured: false,
  },
  {
    id: 6,
    slug: 'music-live-2024',
    title: '2024年度最佳音乐现场表演回顾',
    excerpt: '回顾2024年最令人难忘的音乐现场表演，从演唱会到音乐节，精彩瞬间不容错过。',
    content: '<p>音乐是生活中不可或缺的一部分。红桃视频在线观看为您回顾2024年最精彩的音乐现场表演。</p><h2>演唱会</h2><p>顶级歌手的震撼现场，用音乐点燃全场。</p><h2>音乐节</h2><p>户外音乐节的自由与激情，音乐与自然的完美融合。</p>',
    category: 'music',
    thumbnail: 'https://readdy.ai/api/search-image?query=Music%20concert%20stage%20with%20warm%20golden%20spotlights%2C%20live%20performance%2C%20crowd%20silhouettes%2C%20atmospheric%20haze%2C%20dramatic%20lighting%2C%20professional%20event%20photography%2C%20energetic%20mood&width=800&height=450&seq=article-music-06&orientation=landscape',
    views: 9320,
    date: '2024-11-28',
    author: '红桃编辑',
    featured: false,
  },
  {
    id: 7,
    slug: 'sports-classic-moments',
    title: '体育赛事经典瞬间：那些激动人心的时刻',
    excerpt: '重温体育史上最经典、最激动人心的比赛瞬间，感受体育精神的伟大力量。',
    content: '<p>体育赛事中有太多令人难忘的经典瞬间。红桃视频在线观看带您重温那些激动人心的时刻。</p><h2>足球</h2><p>世界杯、欧冠的经典进球和逆转。</p><h2>篮球</h2><p>NBA赛场上的绝杀和传奇时刻。</p>',
    category: 'sports',
    thumbnail: 'https://readdy.ai/api/search-image?query=Sports%20stadium%20with%20dramatic%20lighting%20at%20sunset%2C%20athletic%20silhouettes%2C%20golden%20hour%20atmosphere%2C%20professional%20sports%20photography%2C%20warm%20tones%2C%20epic%20scale&width=800&height=450&seq=article-sports-07&orientation=landscape',
    views: 11640,
    date: '2024-11-25',
    author: '红桃编辑',
    featured: false,
  },
  {
    id: 8,
    slug: 'game-esports-2024',
    title: '2024年度电竞游戏盘点：最受欢迎的游戏TOP10',
    excerpt: '汇总2024年最受欢迎的电子竞技游戏，从MOBA到FPS，电竞迷不可错过的年度总结。',
    content: '<p>2024年电子竞技持续火爆。红桃视频在线观看为您盘点年度最受欢迎的电竞游戏。</p><h2>MOBA类</h2><p>团队协作与个人技术的完美结合。</p><h2>FPS类</h2><p>紧张刺激的射击体验，考验反应与策略。</p>',
    category: 'game',
    thumbnail: 'https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20RGB%20lighting%2C%20mechanical%20keyboard%2C%20gaming%20monitor%2C%20dark%20room%20with%20colorful%20ambient%20light%2C%20professional%20esports%20aesthetic%2C%20warm%20accent%20colors&width=800&height=450&seq=article-game-08&orientation=landscape',
    views: 14520,
    date: '2024-11-20',
    author: '红桃编辑',
    featured: true,
  },
  {
    id: 9,
    slug: 'film-review-oscar',
    title: '奥斯卡获奖影片深度解读：光影中的艺术',
    excerpt: '深度剖析历年奥斯卡获奖影片的艺术价值与创作手法，理解电影背后的深层含义。',
    content: '<p>奥斯卡金像奖是全球最权威的电影奖项之一。红桃视频在线观看为您深度解读奥斯卡获奖影片。</p><h2>导演艺术</h2><p>大师级导演的创作理念和艺术追求。</p><h2>表演艺术</h2><p>演员们精湛的表演技巧和角色诠释。</p>',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20film%20awards%20ceremony%20stage%20with%20golden%20statue%2C%20red%20carpet%2C%20warm%20cinematic%20lighting%2C%20Hollywood%20glamour%2C%20professional%20photography%2C%20luxurious%20atmosphere&width=800&height=450&seq=article-oscar-09&orientation=landscape',
    views: 6780,
    date: '2024-11-15',
    author: '红桃编辑',
    featured: false,
  },
  {
    id: 10,
    slug: 'tv-drama-analysis',
    title: '国产剧崛起：近年优质国产电视剧深度分析',
    excerpt: '分析近年来国产电视剧的质量提升之路，探讨国产剧在题材、制作和表演上的突破。',
    content: '<p>近年来国产电视剧的质量有了显著提升。红桃视频在线观看为您深度分析国产剧的崛起之路。</p><h2>题材突破</h2><p>从单一类型到多元化发展，国产剧的题材越来越丰富。</p><h2>制作升级</h2><p>服化道、特效、摄影等制作水平的全面提升。</p>',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20film%20set%20with%20traditional%20costumes%2C%20warm%20golden%20lighting%2C%20elegant%20ancient%20architecture%2C%20cinematic%20production%20quality%2C%20rich%20cultural%20atmosphere&width=800&height=450&seq=article-tv-10&orientation=landscape',
    views: 8560,
    date: '2024-11-10',
    author: '红桃编辑',
    featured: false,
  },
  {
    id: 11,
    slug: 'anime-movie-guide',
    title: '动画电影推荐：适合全家一起观看的佳作',
    excerpt: '精选适合全家观看的动画电影，从经典到新作，每一部都充满温暖与感动。',
    content: '<p>动画电影不仅适合孩子，成年人同样能从中获得感动。红桃视频在线观看为您推荐全家共享的动画佳作。</p>',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20movie%20scene%20with%20family%20watching%20together%2C%20warm%20cinematic%20lighting%2C%20cozy%20atmosphere%2C%20animated%20art%20style%2C%20joyful%20mood&width=800&height=450&seq=article-anime-11&orientation=landscape',
    views: 7350,
    date: '2024-11-05',
    author: '红桃编辑',
    featured: false,
  },
  {
    id: 12,
    slug: 'music-recommend-2024',
    title: '2024年度华语音乐推荐：不可错过的优秀作品',
    excerpt: '从流行到独立，从民谣到电子，2024年华语乐坛的优秀作品一网打尽。',
    content: '<p>2024年华语乐坛百花齐放。红桃视频在线观看为您推荐不可错过的优秀华语音乐作品。</p>',
    category: 'music',
    thumbnail: 'https://readdy.ai/api/search-image?query=Music%20recording%20studio%20with%20warm%20vintage%20atmosphere%2C%20microphones%2C%20instruments%2C%20soft%20golden%20lighting%2C%20creative%20space%2C%20professional%20music%20production&width=800&height=450&seq=article-music-12&orientation=landscape',
    views: 6900,
    date: '2024-11-01',
    author: '红桃编辑',
    featured: false,
  },
];

export const aboutData = {
  brandName: '红桃视频在线观看',
  slogan: '免费高清视频播放平台',
  intro: '红桃视频在线观看成立于2020年，是一家专注于提供免费高清视频播放服务的在线平台。经过多年的发展，我们已经成为国内领先的视频播放平台之一，拥有海量视频资源和庞大的用户群体。',
  history: [
    { year: '2020', event: '红桃视频在线观看平台正式上线，开启免费高清视频播放服务' },
    { year: '2021', event: '视频资源突破1万部，月活跃用户突破100万' },
    { year: '2022', event: '完成平台技术升级，支持4K高清画质播放，用户体验大幅提升' },
    { year: '2023', event: '视频资源突破5万部，月活跃用户突破500万，成为行业知名品牌' },
    { year: '2024', event: '视频资源突破10万部，日活跃用户突破1000万，持续引领行业发展' },
  ],
  values: [
    { title: '用户至上', description: '始终以用户体验为核心，不断优化播放流畅度和画质表现，让每一位用户都能享受优质的观影体验。' },
    { title: '内容丰富', description: '持续扩充视频资源库，涵盖电影、电视剧、综艺、动漫、纪录片等多元类型，满足不同用户的需求。' },
    { title: '技术创新', description: '持续投入技术研发，采用先进的视频编解码和CDN加速技术，确保高清流畅的播放体验。' },
    { title: '免费开放', description: '坚持免费策略，让所有用户都能无门槛享受高清视频服务，推动优质内容的广泛传播。' },
  ],
  reputation: {
    title: '信誉保障',
    items: [
      { label: '用户满意度', value: '98.5%' },
      { label: '内容合规率', value: '100%' },
      { label: '服务可用性', value: '99.9%' },
      { label: '版权合作方', value: '200+' },
    ],
  },
  contact: {
    email: 'contact@hongtaovideo.com',
    phone: '400-888-0000',
    address: '北京市朝阳区望京科技园区红桃大厦',
    wechat: 'hongtaovideo',
    workHours: '周一至周日 9:00 - 21:00',
  },
};